import { find } from 'lodash'

export default {
  /**
   * Check if a dashboard has deletion pending
   */
  isDashboardDeletionPending: state => dashboardId =>
    state.dashboardDeletionPending.includes(dashboardId),

  /**
   * Get dashboard by id
   */
  getDashboardById: state => dashboardId =>
    find(state.dashboard, dashboard => dashboard.id === dashboardId)
}
